/**
 * User Agents Tab
 * Displays agents created by the user
 */

import { User } from '../../api'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { Bot } from 'lucide-react'

interface UserAgentsTabProps {
  user: User
}

export function UserAgentsTab({ user }: UserAgentsTabProps) {
  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Bot className="h-5 w-5" />
            User Agents
          </CardTitle>
          <CardDescription>Agents created by this user</CardDescription>
        </CardHeader>
        <CardContent>
          <div className="flex flex-col items-center justify-center py-12 text-center">
            <Bot className="h-12 w-12 text-muted-foreground mb-4" />
            <h3 className="text-lg font-medium mb-2">Agent Details Coming Soon</h3>
            <p className="text-sm text-muted-foreground max-w-md">
              This user has created {user.total_agents || 0} agent
              {user.total_agents !== 1 ? 's' : ''}. Detailed agent information and
              management will be available in a future update.
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  )
}
